import { render, staticRenderFns } from "./Pasos.vue?vue&type=template&id=a9e27a74&"
import script from "./Pasos.vue?vue&type=script&lang=js&"
export * from "./Pasos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports